/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// Page title block. The global bar (project, search, Advisor, balance,
// account) now lives in TopBar inside DashboardLayout, so this only renders
// the page's own title, subtitle and actions. Kept as `Header` so existing
// pages pick up the console redesign without changes.
import React from 'react';
import { PageHeader } from '../console/ui';

interface HeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  /** @deprecated balance is shown in the global top bar. */
  walletBalance?: string;
}

const Header: React.FC<HeaderProps> = ({ title, subtitle, actions }) => (
  <div className="w-full max-w-[1280px] px-4 pt-5 sm:px-7 sm:pt-7">
    <PageHeader title={title} subtitle={subtitle} actions={actions} />
  </div>
);

export default Header;
